import { Provider } from 'react-redux';
import store from '../services/store';

export const withReduxProvider = (Component: any) => (props: any) =>
  (
    <Provider store={store}>
      <Component {...props} />
    </Provider>
  );
